module.exports = __webpack_public_path__ + "static/media/mountain.c95f08a4.png";